(function(config) {
    'use strict';

    angular.module('format.services', [
            'ngResource'
        ])
        .factory('formatDataSrvc', formatDataSrvc)
        .factory('formatSrvc', formatSrvc)
        .factory('formatGroupDataSrvc',formatGroupDataSrvc)
        .factory('formatGroupSrvc', formatGroupSrvc);

    formatDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function formatDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/format/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/format/',
                params: {
                    page: '@page',
                    format_group: '@format_group',
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            },
            formatsList: {
                method: 'GET',
                url: config.api + '/api/v1/format/admin_formats_list/',
            },
            formatsAsOptions: {
                method: 'GET',
                url: config.api + '/api/v1/format/admin_formats_as_options/',
                isArray: true
            },
            montageFormat: {
                method: 'GET',
                url: config.api + '/api/v1/format/admin_montage_format/',
                isArray: true,
            },
            montageProductFilterFormat: {
                method: 'GET',
                url: config.api + '/api/v1/format/admin_montage_product_filter_format/',
                isArray: true
            },
            orderProductFormats: {
                method: 'GET',
                url: config.api + '/api/v1/format/admin_order_products_formats/',
                isArray: true
            }
        });
    }

    formatSrvc.$inject = ['formatDataSrvc', 'modalSrvc'];

    function formatSrvc(formatDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    formatDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    formatGroupDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function formatGroupDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/format_groups/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET',
            },
            list: {
                method: 'GET',
                url: config.api + '/api/v1/format_groups/',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            update: {
                method: 'PATCH',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            },
            forFormatsList: {
                method: 'GET',
                isArray: true,
                url: config.api + '/api/v1/format_groups/admin_for_formats_list/'
            }
        });
    }

    formatGroupSrvc.$inject = ['formatGroupDataSrvc', 'modalSrvc'];

    function formatGroupSrvc(formatGroupDataSrvc, modalSrvc) {

        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    formatGroupDataSrvc.delete({
                        pk: pk
                    }).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

})(window.config);
